export default "__VITE_ASSET__76dd26aa__"